import { Navigate } from "react-router-dom";
import { ORG_NAV_FEATURE_FLAGS } from "../../config/featureFlags";
import { ADMIN_HOME } from "@/lib/postLoginDestination";

interface OrgFeatureRouteProps {
  featureKey: keyof typeof ORG_NAV_FEATURE_FLAGS;
  children: React.ReactNode;
}

const OrgFeatureRoute = ({ featureKey, children }: OrgFeatureRouteProps) => {
  if (!ORG_NAV_FEATURE_FLAGS[featureKey]) {
    return <Navigate to={ADMIN_HOME} replace />;
  }
  return <>{children}</>;
};

export default OrgFeatureRoute;
